/**
 * Agent A8 / AGENT-BC2: bottom-strip combo charts row.
 *
 * Layout-only shell. Each cell renders the corresponding chart component,
 * which is independently subscribed to the shared `useReportData` hook
 * (react-query dedupes on the ["dashboard-report", serialized] key, so all
 * four charts plus A7's metrics table share one network round-trip).
 *
 * AGENT-BC2: grid widened from 2-up to 4-up (2 columns x 2 rows). The two
 * new bookmark-variant line charts (QuotesOrdersChart, UnitsQuotedSoldChart)
 * occupy the second row and mirror PBI's bookmark navigator themes for
 * "by Number of Quotes / Orders" and "by Quantity of Units Quoted / Sold".
 */

import "./ChartsRow.css";
import RevenueQuoteFunnelChart from "./RevenueQuoteFunnelChart";
import RevenueOnlineOrdersChart from "./RevenueOnlineOrdersChart";
import QuotesOrdersChart from "./QuotesOrdersChart";
import UnitsQuotedSoldChart from "./UnitsQuotedSoldChart";

export function ChartsRow(): JSX.Element {
  return (
    <div className="charts-row">
      <div className="charts-row__cell">
        <RevenueQuoteFunnelChart />
      </div>
      <div className="charts-row__cell">
        <RevenueOnlineOrdersChart />
      </div>
      <div className="charts-row__cell">
        <QuotesOrdersChart />
      </div>
      <div className="charts-row__cell">
        <UnitsQuotedSoldChart />
      </div>
    </div>
  );
}

export default ChartsRow;
